import { useEffect } from "react";
//import { useMemo } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import logo from "../../assets/images/RAPS-Logo.png";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { retrieveUserInfo } from "../../redux/slice/sso/userinfo.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import useAuth from "../../hooks/useAuth";
//import LoadAds from "../../components/advertisement/load-convergence-ads";

const ConvergenceHeader = () => {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const path = "%2FConvergence-2025%2FSite-Nav";
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu);
  const { checkLogin } = useSelector((state: RootState) => state.loggedIn);
  const userInfo = useSelector((state: RootState) => state.userInfo);
  const userInfoData = userInfo.data;
  //const cachedGoogleAdsLoader = useMemo(() => <LoadAds />, []);

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (!userInfo.loading && auth.getUser()?.accessToken && userInfo.data?.result === undefined) {
      dispatch(retrieveUserInfo());
    }
  }, [dispatch]);

  return (
    <>
      {/*cachedGoogleAdsLoader*/}
      <header className="sticky-top">
        <Navbar bg="dark" className="bg-primary navbar-dark" expand="lg">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
                return item.childNavigation?.length === 0 ? (
                  <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
                ) : (
                  <NavDropdown id={"nav-dropdown-dark-example-" + index} title={item.text} menuVariant="dark" key={index} renderMenuOnMount={true}>
                    {item.childNavigation?.map((itm, indx) => {
                      return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>;
                    })}
                  </NavDropdown>
                );
              })}
            </Nav>
          </Navbar.Collapse>
          <div className="form-inline">
            {checkLogin.isLoggedIn && userInfoData.result && <span className="navbar-brand greeting">Hi, {userInfoData.result?.firstName}</span>}
            <a className="navbar-brand" style={{ marginRight: 0 }} href="/"><img alt="RAPS.org" src={logo} /></a>
          </div>
        </Navbar>
      </header>
    </>
  );
};

export default ConvergenceHeader;